import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/SPANavigation';
import Footer from './components/Footer';
import TaskManagerPage from './pages/TaskManagerPage';
import { TaskDetailPage } from './pages/TaskDetailPage';
import TaskFormPage from './pages/TaskFormPage';
import './App.css';

/**
 * React SPA - Task Manager Only (Advanced Mode)
 * This is a standalone Task Manager app with site navigation
 * Matches the Next.js navigation for consistent user experience
 */
const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router basename="/task-manager-spa">
        <div className="App">
          <Navigation />
          
          {/* Advanced Mode Warning Banner */}
          <div style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '12px 20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            borderBottom: '3px solid #5a67d8',
            boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
          }}>
            <div style={{ textAlign: 'center' }}>
              ⚡ <strong>Advanced Mode</strong> - Enterprise SPA
            </div>
          </div>
          
          {/* Task Manager Routes Only */}
          <Routes>
            <Route path="/" element={<TaskManagerPage />} />
            <Route path="/details/:id" element={<TaskDetailPage />} />
            <Route path="/tasks/new" element={<TaskFormPage />} />
            <Route path="/tasks/edit/:id" element={<TaskFormPage />} />
          </Routes>
          
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
